module.exports = __webpack_public_path__ + "img/Perdues@3x.02cacc83.png";